/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';

import 'react-datepicker/dist/react-datepicker.css';
import './EditGpaModal.scss';

const EditUserModal = ({
  show, toggle, onSubmit, values,
}) => {
  const userRole = localStorage?.getItem('role');
  const showHideClassName = show ? 'edit-user-modal display-block' : 'edit-user-modal display-none';
  const {
    register, handleSubmit, setValue, formState: { errors },
  } = useForm();

  useEffect(() => {
    if (values) {
      setValue('nomineeIdentity', values.nomineeIdentity);
      setValue('nomineeName', values.nomineeName);
      setValue('enrolmentId', values?.enrolmentId);
    }
  }, [setValue, values]);

  const submit = ({
    nomineeIdentity,
    nomineeName,
    enrolmentId,
  }) => {
    toggle();
    onSubmit({
      nomineeIdentity,
      nomineeName,
      enrolmentId,
    });
  };

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        <div className="row">
          <div className="col-12 d-flex end">
            <button type="button" className="modal-main__button" onClick={toggle}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="col-12">
            <div className="form">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Nominee Name</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="nomineeName"
                            name="nomineeName"
                            placeholder="Nominee Name"
                            {...register('nomineeName', { required: { value: true, message: 'Nominee Name is required' } })}
                          />
                          {errors.nomineeName && <div className="form__error">{errors.nomineeName.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Nominee Relationship</span>
                        </div>
                        <div className="col-12">
                          <select
                            id="nomineeIdentity"
                            name="nomineeIdentity"
                            placeholder="Select Relationship"
                            className="form__field"
                            {...register('nomineeIdentity', { required: { value: true, message: 'Nominee Relationship is required' } })}
                          >
                            <option value="WIFE">Wife</option>
                            <option value="HUSBAND">Husband</option>
                            <option value="MOTHER">Mother</option>
                            <option value="FATHER">Father</option>
                            <option value="SON">Son</option>
                            <option value="DAUGHTER">Daughter</option>
                            <option value="BROTHER">Brother</option>
                            <option value="SISTER">Sister</option>
                          </select>
                          {errors.nomineeIdentity && <div className="form__error">{errors.nomineeIdentity.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form__item">
                    <label htmlFor="frequency">
                      <div className="row middle">
                        <div className="col-12">
                          <span className="form__label">Enrollment Id</span>
                        </div>
                        <div className="col-12">
                          <input
                            className="form__field"
                            type="text"
                            id="enrolmentId"
                            name="enrolmentId"
                            placeholder="Enrollment Id"
                            disabled
                            {...register('enrolmentId', { required: { value: false, message: 'IFSC Code is required' } })}
                          />
                          {errors.enrolmentId && <div className="form__error">{errors.enrolmentId.message}</div>}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form__item">
                    <div className="row">
                      <div className="col-12 d-flex-col middle">
                        <button type="button" className="form__button" onClick={handleSubmit(submit)}>Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditUserModal;
